export default "__VITE_PUBLIC_ASSET__cd966ce7__"